var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { css, html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { DefaultFftSize, DefaultMinDecibels, DefaultMaxDecibels, } from "./constants.js";
import { SpectrumTapEvent } from "./events.js";
import { Mapping } from "../coordinates/mapping.js";
import { Zoom, DefaultZoom } from "../coordinates/zoom.js";
let RrScopeLine = class RrScopeLine extends LitElement {
    static get styles() {
        return [
            css `
        #scope {
          color: var(--rr-scope-color, yellow);
          width: 100%;
          height: 100%;
        }
      `,
        ];
    }
    render() {
        return html `<canvas id="scope"></canvas>`;
    }
    constructor() {
        super();
        this.minDecibels = DefaultMinDecibels;
        this.maxDecibels = DefaultMaxDecibels;
        this.fftSize = DefaultFftSize;
        this.zoom = DefaultZoom;
        this.spectrum = new Float32Array(this.fftSize);
        this.width = this.fftSize;
        this.addEventListener("click", (e) => this.onClick(e));
    }
    addFloatSpectrum(spectrum) {
        if (this.fftSize != spectrum.length) {
            this.fftSize = spectrum.length;
            this.spectrum = new Float32Array(this.fftSize);
        }
        this.spectrum.set(spectrum);
        this.redraw();
    }
    updated(changed) {
        super.updated(changed);
        if (!changed.has("zoom"))
            return;
        this.redraw();
    }
    redraw() {
        let ctx = this.getContext();
        if (!ctx)
            return;
        const width = ctx.canvas.offsetWidth;
        const height = ctx.canvas.offsetHeight;
        if (ctx.canvas.width != width)
            ctx.canvas.width = width;
        if (ctx.canvas.height != height)
            ctx.canvas.height = height;
        if (this.width != width) {
            this.width = width;
        }
        const min = this.minDecibels;
        const max = this.maxDecibels;
        const range = max - min;
        const mul = (1 - height) / range;
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.strokeStyle = getComputedStyle(this.canvas).getPropertyValue("color");
        ctx.beginPath();
        const mapping = new Mapping(this.zoom, this.width, this.fftSize);
        const y = (bin) => (this.spectrum[mapping.screenBinToFftBin(bin)] - max) * mul;
        if (mapping.visibleBins <= width) {
            const x = (bin) => mapping.binNumberToCenterCoord(bin);
            ctx.moveTo(x(mapping.leftBin - 1), y(mapping.leftBin - 1));
            for (let i = 0; i < mapping.visibleBins + 1; ++i) {
                ctx.lineTo(x(mapping.leftBin + i), y(mapping.leftBin + i));
            }
        }
        else {
            for (let x = 0; x < width; ++x) {
                let leftBin = mapping.leftCoordToBinNumber(x);
                let rightBin = mapping.leftCoordToBinNumber(x + 1);
                let min = y(leftBin);
                for (let b = leftBin + 1; b < rightBin; ++b) {
                    min = Math.min(min, y(b));
                }
                if (x == 0) {
                    ctx.moveTo(x, min);
                }
                else {
                    ctx.lineTo(x, min);
                }
            }
        }
        ctx.stroke();
    }
    onClick(e) {
        const mapping = new Mapping(this.zoom, this.width, this.fftSize);
        let fraction = mapping.unzoomed(e.offsetX / this.offsetWidth);
        this.dispatchEvent(new SpectrumTapEvent({ fraction, target: "scope" }));
        e.preventDefault();
    }
    getContext() {
        if (this.context)
            return this.context;
        if (!this.canvas)
            return;
        this.canvas.width = this.fftSize;
        this.canvas.height = this.maxDecibels - this.minDecibels;
        this.context = this.canvas.getContext("2d");
        return this.context;
    }
};
__decorate([
    property({ type: Number, reflect: true, attribute: "min-decibels" }),
    __metadata("design:type", Number)
], RrScopeLine.prototype, "minDecibels", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: "max-decibels" }),
    __metadata("design:type", Number)
], RrScopeLine.prototype, "maxDecibels", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], RrScopeLine.prototype, "fftSize", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", typeof (_a = typeof Zoom !== "undefined" && Zoom) === "function" ? _a : Object)
], RrScopeLine.prototype, "zoom", void 0);
__decorate([
    query("#scope"),
    __metadata("design:type", typeof (_b = typeof HTMLCanvasElement !== "undefined" && HTMLCanvasElement) === "function" ? _b : Object)
], RrScopeLine.prototype, "canvas", void 0);
RrScopeLine = __decorate([
    customElement("rr-scope-line"),
    __metadata("design:paramtypes", [])
], RrScopeLine);
export { RrScopeLine };
